import { createReducer, on } from '@ngrx/store';
import * as clientActions from './client.actions';

export interface IClientState {
  showMobileMenu: boolean;
}

export const clientReducer = createReducer(
  {
    showMobileMenu: false,
  },
  on(clientActions.openMobileMenu, (state) => ({
    ...state,
    showMobileMenu: true,
  })),
  on(clientActions.closeMobileMenu, (state) => ({
    ...state,
    showMobileMenu: false,
  })),
);
